import { useSelector } from 'react-redux';

import { useConsultantChatHost } from './useConsultantChatHost';
import { consultantChatIdSelector } from '../../selectors/consultantChat';
import { getRegionId } from '../../selectors/newbuilding';
import { getGaLabel } from '../../selectors/analytics';

interface IParams {
  isChatOpened: boolean;
}

export const useConsultantChatUrl = ({ isChatOpened }: IParams): string | undefined => {
  const chatHost = useConsultantChatHost();
  const chatId = useSelector(consultantChatIdSelector);
  const gaLabel = useSelector(getGaLabel);
  const regionId = useSelector(getRegionId);

  if (!isChatOpened) {
    return undefined;
  }

  return (
    `${chatHost}/dialogs/?hostType=frame&chatId=${chatId}` +
    `&region=${regionId}` +
    `${gaLabel ? '&gaLabel=' + encodeURIComponent(gaLabel) : ''}` +
    `&source=CardJK&pageType=CardJK`
  );
};
